const trimTrailingSlash = (value) => String(value || '').replace(/\/+$/, '');

export const PUBLIC_SITE_URL =
    trimTrailingSlash(process.env.NEXT_PUBLIC_SITE_URL) ||
    trimTrailingSlash(process.env.NEXT_PUBLIC_FRONT_ROUT) ||
    'https://front.rayanox.com';

export const Routes = {
    //====================== WEBSITE URLS ======================
    SITE_URL: PUBLIC_SITE_URL,
    CANONICAL_URL: PUBLIC_SITE_URL,

    //====================== ADMIN ROUTES ======================
    HOME: '/',

    DASHBOARD_login: '/login',
    DASHBOARD_register: '/register',
    DASHBOARD_forgot_password: '/forgot-password',
    DASHBOARD_password_reset: '/password-reset',
    DASHBOARD_verify_email: '/verify-email',

    DASHBOARD: '/dashboard',

    DASHBOARD_manage_images: '/dashboard/manage-images',

    DASHBOARD_manage_tours: '/dashboard/manage-tours/list',
    DASHBOARD_manage_tours_add: '/dashboard/manage-tours/add',
    DASHBOARD_manage_tours_edit: '/dashboard/manage-tours/edit/',
    DASHBOARD_manage_tours_categories_list: '/dashboard/manage-tours/categories/list',
    DASHBOARD_manage_tours_categories_add: '/dashboard/manage-tours/categories/add',
    DASHBOARD_manage_tours_categories_edit: '/dashboard/manage-tours/categories/edit/',

    DASHBOARD_manage_packages_list: '/dashboard/manage-packages/list',
    DASHBOARD_manage_packages_add: '/dashboard/manage-packages/add',
    DASHBOARD_manage_packages_edit: '/dashboard/manage-packages/edit/',
    DASHBOARD_manage_packages_categories_list: '/dashboard/manage-packages/categories/list',
    DASHBOARD_manage_packages_categories_add: '/dashboard/manage-packages/categories/add',
    DASHBOARD_manage_packages_categories_edit: '/dashboard/manage-packages/categories/edit/',

    DASHBOARD_manage_guides_list: '/dashboard/manage-packages/guides/list',
    DASHBOARD_manage_guides_add: '/dashboard/manage-packages/guides/add',
    DASHBOARD_manage_guides_edit: '/dashboard/manage-packages/guides/edit/',

    DASHBOARD_manage_city_breaks: '/dashboard/manage-packages/list',
    DASHBOARD_manage_city_breaks_add: '/dashboard/manage-packages/add',
    DASHBOARD_manage_city_breaks_edit: '/dashboard/manage-packages/edit/',

    DASHBOARD_manage_city_breaks_facilities: '/dashboard/manage-packages/facilities/list',
    DASHBOARD_manage_city_breaks_facilities_add: '/dashboard/manage-packages/facilities/add',
    DASHBOARD_manage_city_breaks_facilities_edit: '/dashboard/manage-packages/facilities/edit/',

    DASHBOARD_manage_activities: '/dashboard/manage-activities/list',
    DASHBOARD_manage_activities_add: '/dashboard/manage-activities/add',
    DASHBOARD_manage_activities_edit: '/dashboard/manage-activities/edit/',

    DASHBOARD_manage_activities_types: '/dashboard/manage-activities/types/list',
    DASHBOARD_manage_activities_types_add: '/dashboard/manage-activities/types/add',
    DASHBOARD_manage_activities_types_edit: '/dashboard/manage-activities/types/edit/',

    DASHBOARD_manage_events: '/dashboard/manage-events/list',
    DASHBOARD_manage_events_add: '/dashboard/manage-events/add',
    DASHBOARD_manage_events_edit: '/dashboard/manage-events/edit/',
    DASHBOARD_manage_events_categories_list: '/dashboard/manage-events/categories/list',
    DASHBOARD_manage_events_categories_add: '/dashboard/manage-events/categories/add',
    DASHBOARD_manage_events_categories_edit: '/dashboard/manage-events/categories/edit/',

    DASHBOARD_manage_luxury_travels: '/dashboard/manage-luxury-travels/list',
    DASHBOARD_manage_luxury_travels_add: '/dashboard/manage-luxury-travels/add',
    DASHBOARD_manage_luxury_travels_edit: '/dashboard/manage-luxury-travels/edit/',
    DASHBOARD_manage_luxury_travels_categories_list: '/dashboard/manage-luxury-travels/categories/list',
    DASHBOARD_manage_luxury_travels_categories_add: '/dashboard/manage-luxury-travels/categories/add',
    DASHBOARD_manage_luxury_travels_categories_edit: '/dashboard/manage-luxury-travels/categories/edit/',

    DASHBOARD_manage_events_types: '/dashboard/manage-events/types/list',
    DASHBOARD_manage_events_types_add: '/dashboard/manage-events/types/add',
    DASHBOARD_manage_events_types_edit: '/dashboard/manage-events/types/edit/',

    DASHBOARD_manage_cars: '/dashboard/manage-cars/list',
    DASHBOARD_manage_cars_add: '/dashboard/manage-cars/add',
    DASHBOARD_manage_cars_edit: '/dashboard/manage-cars/edit/',

    DASHBOARD_manage_cars_types: '/dashboard/manage-cars/types/list',
    DASHBOARD_manage_cars_types_add: '/dashboard/manage-cars/types/add',
    DASHBOARD_manage_cars_types_edit: '/dashboard/manage-cars/types/edit/',

    DASHBOARD_manage_destinations: '/dashboard/manage-destinations/list',
    DASHBOARD_manage_destinations_add: '/dashboard/manage-destinations/add',
    DASHBOARD_manage_destinations_edit: '/dashboard/manage-destinations/edit/',
    DASHBOARD_manage_destinations_categories_list: '/dashboard/manage-destinations/categories/list',
    DASHBOARD_manage_destinations_categories_add: '/dashboard/manage-destinations/categories/add',
    DASHBOARD_manage_destinations_categories_edit: '/dashboard/manage-destinations/categories/edit/',

    DASHBOARD_manage_pages: '/dashboard/manage-pages/list',
    DASHBOARD_manage_pages_add: '/dashboard/manage-pages/add',
    DASHBOARD_manage_pages_edit: '/dashboard/manage-pages/edit/',

    DASHBOARD_manage_articles: '/dashboard/manage-blog/articles/list',
    DASHBOARD_manage_articles_add: '/dashboard/manage-blog/articles/add',
    DASHBOARD_manage_articles_edit: '/dashboard/manage-blog/articles/edit/',

    DASHBOARD_manage_categories: '/dashboard/manage-blog/categories/list',
    DASHBOARD_manage_categories_add: '/dashboard/manage-blog/categories/add',
    DASHBOARD_manage_categories_edit: '/dashboard/manage-blog/categories/edit/',

    DASHBOARD_manage_tags: '/dashboard/manage-blog/tags/list',
    DASHBOARD_manage_tags_add: '/dashboard/manage-blog/tags/add',
    DASHBOARD_manage_tags_edit: '/dashboard/manage-blog/tags/edit/',

    DASHBOARD_manage_travel_guides: '/dashboard/manage-travel-guides/list',
    DASHBOARD_manage_travel_guides_add: '/dashboard/manage-travel-guides/add',
    DASHBOARD_manage_travel_guides_edit: '/dashboard/manage-travel-guides/edit/',

    DASHBOARD_manage_travel_guide_categories: '/dashboard/manage-travel-guides/categories/list',
    DASHBOARD_manage_travel_guide_categories_add: '/dashboard/manage-travel-guides/categories/add',
    DASHBOARD_manage_travel_guide_categories_edit: '/dashboard/manage-travel-guides/categories/edit/',

    DASHBOARD_manage_reviews: '/dashboard/manage-reviews',
    DASHBOARD_manage_reviews_add: '/dashboard/manage-reviews/add',
    DASHBOARD_manage_reviews_edit: '/dashboard/manage-reviews/edit/',

    DASHBOARD_manage_contact_form: '/dashboard/manage-forms/contact-form',
    DASHBOARD_manage_contact_form_mail: '/dashboard/manage-forms/contact-form/mail/',
    DASHBOARD_manage_tailor_made_travel: '/dashboard/manage-forms/tailor-made',
    DASHBOARD_manage_tailor_made_single: '/dashboard/manage-forms/tailor-made/order/',
    DASHBOARD_manage_activity_quote: '/dashboard/manage-forms/activities-quote',
    DASHBOARD_manage_activity_quote_single: '/dashboard/manage-forms/activities-quote/order/',
    DASHBOARD_manage_tour_quote: '/dashboard/manage-forms/tours-quote',
    DASHBOARD_manage_tour_quote_single: '/dashboard/manage-forms/tours-quote/order/',
    DASHBOARD_manage_city_breaks_quote: '/dashboard/manage-forms/city-breaks-quote',
    DASHBOARD_manage_city_breaks_quote_single: '/dashboard/manage-forms/city-breaks-quote/order/',
    DASHBOARD_manage_events_quote: '/dashboard/manage-forms/events-quote',
    DASHBOARD_manage_events_quote_single: '/dashboard/manage-forms/events-quote/order/',
    DASHBOARD_manage_cars_quote: '/dashboard/manage-forms/cars-quote',
    DASHBOARD_manage_packages_quote: '/dashboard/manage-forms/packages',
    DASHBOARD_manage_packages_quote_single: '/dashboard/manage-forms/packages/order/',

    DASHBOARD_manage_reviews: '/dashboard/manage-reviews',
    DASHBOARD_manage_reviews_show: '/dashboard/manage-reviews/review',

    DASHBOARD_manage_settings: '/dashboard/manage-setting',

    DASHBOARD_manage_users: '/dashboard/manage-users',
    DASHBOARD_manage_users_add: '/dashboard/manage-users/add',
    DASHBOARD_manage_users_edit: '/dashboard/manage-users/edit/',

    DASHBOARD_manage_faqs: '/dashboard/manage-faqs',
    DASHBOARD_manage_faqs_add: '/dashboard/manage-faqs/add',
    DASHBOARD_manage_faqs_edit: '/dashboard/manage-faqs/edit/',

    DASHBOARD_manage_slider: '/dashboard/slider-home',

    FRONT_contact: '/contact-us',
    FRONT_tailor_made: '/tailor-made',

    FRONT_tours: '/tours',
    FRONT_tour: '/tours/',
    FRONT_tours_category: '/tours/category/',
    FRONT_tours_types: '/tours/t',
    FRONT_tours_type: '/tours/t/',

    FRONT_city_breaks: '/packages',
    FRONT_city_break: '/packages/',
    FRONT_city_breaks_facilities: '/packages/t',
    FRONT_city_breaks_facility: '/packages/t/',

    FRONT_activities: '/excursions',
    FRONT_activity: '/excursions/',
    FRONT_activities_types: '/excursions/t',
    FRONT_activities_type: '/excursions/t/',

    FRONT_packages: '/packages',
    FRONT_package: '/packages/',
    FRONT_packages_category: '/packages/category/',
    FRONT_package_tag: '/packages/tag/',
    FRONT_package_duration: '/packages/duration/',
    FRONT_package_from: '/packages/from/',

    FRONT_types: '/t',
    FRONT_types_tours: '/t/tours',
    FRONT_types_activities: '/t/excursions',
    FRONT_type: '/t/',

    FRONT_events: '/events',
    FRONT_events_category: '/events/category/',
    FRONT_event: '/events/',
    FRONT_events_types: '/events/t',
    FRONT_events_type: '/events/t/',

    FRONT_luxury_travels: '/exclusive-experiences',
    FRONT_luxury_travel: '/exclusive-experiences/',
    FRONT_luxury_travel_category: '/exclusive-experiences/category/',

    FRONT_destinations: '/destinations',
    FRONT_destination: '/destinations/',
    FRONT_destination_category: '/destinations/category/',

    FRONT_blog: '/blog',
    FRONT_blog_article: '/blog/',
    FRONT_blog_categories: '/blog/categories',
    FRONT_blog_category: '/blog/categories/',
    FRONT_blog_tags: '/blog/tags',
    FRONT_blog_tag: '/blog/tags/',

    // Travel guides (front)
    FRONT_travel_guides: '/travel-guides',
    FRONT_travel_guide: '/travel-guides/',
    FRONT_travel_guide_categories: '/travel-guides/categories',
    FRONT_travel_guide_category: '/travel-guides/categories/',

    FRONT_search: '/search/',
    FRONT_customer_reviews: '/customer-reviews/',
    FRONT_faqs: '/faqs',

    FRONT_thank_you: '/thank-you',

    FRONT_about_us: '/about-us',
    FRONT_terms_of_sale: '/term-of-sale',
    FRONT_privacy_policy: '/privacy-policy',
    FRONT_twitter: 'https://twitter.com/rayanoxevents',
    FRONT_facebook: 'https://facebook.com/rayanoxevents',
    FRONT_instagram: 'https://instagram.com/rayanoxevents',
    FRONT_Linkedin: 'https://linkedin.com/company/rayanoxevents',
    FRONT_Pinterest: 'https://pinterest.com/rayanoxevents',
    FRONT_email: 'mailto:sales@morocco-tours.com',
    FRONT_phone: 'tel:+212524358589',
    FRONT_whatsapp: 'https://wa.me/212770852738',
};

export const ApiRoutes = {
    FRONT_ROUT: PUBLIC_SITE_URL,
    API_ROUT_SERVER: process.env.NEXT_PUBLIC_BACKEND_URL,
    ASSETS_ENDPOINT: process.env.NEXT_PUBLIC_CDN_SUBDOMAIN,
    API_ROUT: process.env.NEXT_PUBLIC_BACKEND_URL,
    API_CSRF_COOKIE: '/sanctum/csrf-cookie',
    API_EMAIL_VEREFICATION: '/email/verification-notification',
    API_GET_AUTH: '/api/auth',
    API_GET_USER: '/api/user',
    API_GET_USER_LOGIN: '/api/get-user-login',
    API_LOGIN_URL: '/login',
    API_LOGOUT: '/logout',
    API_REGISTER: '/register',
    API_FORGOT_PASSWORD: '/forgot-password',
    API_RESET_PASSWORD: '/reset-password',

    API_data_dashboard: '/api/dashboard/get-data-dashboard',
    API_get_images: '/api/dashboard/get-images',

    API_get_tours: '/api/dashboard/get-tours',
    API_search_tours: '/api/dashboard/search-tour',
    API_delete_tour: '/api/dashboard/delete-tour/',
    API_bulk_delete_tours: '/api/dashboard/delete-tours-bulk',
    API_add_tour: '/api/dashboard/add-tour',
    API_create_tour: '/api/dashboard/create-tour',
    API_edit_tour: '/api/dashboard/edit-tour/',
    API_update_tour: '/api/dashboard/update-tour/',
    API_update_programmes: '/api/dashboard/update-programmes/',

    API_get_city_breaks: '/api/dashboard/get-city-breaks',
    API_search_city_breaks: '/api/dashboard/search-city-break',
    API_delete_city_break: '/api/dashboard/delete-city-break/',
    API_add_city_break: '/api/dashboard/add-city-break',
    API_create_city_break: '/api/dashboard/create-city-break',
    API_edit_city_break: '/api/dashboard/edit-city-break/',
    API_update_city_break: '/api/dashboard/update-city-break/',
    API_update_programmes_city_break: '/api/dashboard/update-programmes-city-break/',

    API_get_activities: '/api/dashboard/get-activities',
    API_search_activity: '/api/dashboard/search-activity',
    API_delete_activity: '/api/dashboard/delete-activity/',
    API_add_activity: '/api/dashboard/add-activity',
    API_create_activity: '/api/dashboard/create-activity',
    API_edit_activity: '/api/dashboard/edit-activity/',
    API_update_activity: '/api/dashboard/update-activity/',

    API_get_events: '/api/dashboard/get-events',
    API_get_all_events: '/api/dashboard/get-all-events',
    API_search_event: '/api/dashboard/search-event',
    API_delete_event: '/api/dashboard/delete-event/',
    API_bulk_delete_events: '/api/dashboard/delete-events-bulk',
    API_add_event: '/api/dashboard/add-event',
    API_create_event: '/api/dashboard/create-event',
    API_edit_event: '/api/dashboard/edit-event/',
    API_update_event: '/api/dashboard/update-event/',

    API_get_luxury_travels: '/api/dashboard/get-luxury-travels',
    API_get_all_luxury_travels: '/api/dashboard/get-all-luxury-travels',
    API_get_all_travel_guides: '/api/dashboard/get-all-travel-guides',
    API_delete_luxury_travel: '/api/dashboard/delete-luxury-travel/',
    API_bulk_delete_luxury_travels: '/api/dashboard/delete-luxury-travels-bulk',
    API_add_luxury_travel: '/api/dashboard/add-luxury-travel',
    API_create_luxury_travel: '/api/dashboard/create-luxury-travel',
    API_edit_luxury_travel: '/api/dashboard/edit-luxury-travel/',
    API_update_luxury_travel: '/api/dashboard/update-luxury-travel/',

    API_get_cars: '/api/dashboard/get-cars',
    API_search_car: '/api/dashboard/search-car',
    API_delete_car: '/api/dashboard/delete-car/',
    API_add_car: '/api/dashboard/add-car',
    API_create_car: '/api/dashboard/create-car',
    API_edit_car: '/api/dashboard/edit-car/',
    API_update_car: '/api/dashboard/update-car/',

    API_get_destinations: '/api/dashboard/get-destinations',
    API_search_destination: '/api/dashboard/search-destination',
    API_delete_destination: '/api/dashboard/delete-destination/',
    API_bulk_delete_destinations: '/api/dashboard/delete-destinations-bulk',
    API_create_destination: '/api/dashboard/create-destination',
    API_edit_destination: '/api/dashboard/edit-destination/',
    API_update_destination: '/api/dashboard/update-destination/',

    API_get_types: '/api/dashboard/get-types',
    API_search_type: '/api/dashboard/search-type',
    API_delete_type: '/api/dashboard/delete-type/',
    API_create_type: '/api/dashboard/create-type',
    API_edit_type: '/api/dashboard/edit-type/',
    API_update_type: '/api/dashboard/update-type/',
    API_get_types_post_dashboard: '/api/dashboard/get-types-post-dachboard',

    API_get_facilities: '/api/dashboard/get-facilities',
    API_search_facility: '/api/dashboard/search-facility',
    API_delete_facility: '/api/dashboard/delete-facility/',
    API_create_facility: '/api/dashboard/create-facility',
    API_edit_facility: '/api/dashboard/edit-facility/',
    API_update_facility: '/api/dashboard/update-facility/',
    API_get_facilities_post_dashboard: '/api/dashboard/get-facilities-post-dachboard',

    API_get_pages: '/api/dashboard/get-pages',
    API_search_page: '/api/dashboard/search-page',
    API_delete_page: '/api/dashboard/delete-page/',
    API_create_page: '/api/dashboard/create-page',
    API_edit_page: '/api/dashboard/edit-page/',
    API_update_page: '/api/dashboard/update-page/',

    API_get_categories: '/api/dashboard/get-categories',
    API_search_category: '/api/dashboard/search-category',
    API_delete_category: '/api/dashboard/delete-category/',
    API_create_category: '/api/dashboard/create-category',
    API_edit_category: '/api/dashboard/edit-category/',
    API_update_category: '/api/dashboard/update-category/',
    API_bulk_delete_categories: '/api/dashboard/delete-categories-bulk',

    API_get_tags: '/api/dashboard/get-tags',
    API_search_tag: '/api/dashboard/search-tag',
    API_delete_tag: '/api/dashboard/delete-tag/',
    API_bulk_delete_tags: '/api/dashboard/delete-tags-bulk',
    API_create_tag: '/api/dashboard/create-tag',
    API_edit_tag: '/api/dashboard/edit-tag/',
    API_update_tag: '/api/dashboard/update-tag/',

    API_get_articles: '/api/dashboard/get-articles',
    API_search_article: '/api/dashboard/search-article',

    API_dashboard_get_travel_guides: '/api/dashboard/get-travel-guides',
    API_search_travel_guide: '/api/dashboard/search-travel-guide',
    API_add_travel_guide: '/api/dashboard/add-travel-guide',
    API_create_travel_guide: '/api/dashboard/create-travel-guide',
    API_edit_travel_guide: '/api/dashboard/edit-travel-guide/',
    API_update_travel_guide: '/api/dashboard/update-travel-guide/',
    API_delete_travel_guide: '/api/dashboard/delete-travel-guide/',
    API_bulk_delete_travel_guides: '/api/dashboard/delete-travel-guides-bulk',

    API_get_travel_guide_categories: '/api/dashboard/get-travel-guide-categories',
    API_search_travel_guide_category: '/api/dashboard/search-travel-guide-category',
    API_create_travel_guide_category: '/api/dashboard/create-travel-guide-category',
    API_edit_travel_guide_category: '/api/dashboard/edit-travel-guide-category/',
    API_update_travel_guide_category: '/api/dashboard/update-travel-guide-category/',
    API_delete_travel_guide_category: '/api/dashboard/delete-travel-guide-category/',
    API_delete_article: '/api/dashboard/delete-article/',
    API_bulk_delete_articles: '/api/dashboard/delete-articles-bulk',
    API_add_article: '/api/dashboard/add-article',
    API_create_article: '/api/dashboard/create-article',
    API_edit_article: '/api/dashboard/edit-article/',
    API_update_article: '/api/dashboard/update-article/',

    API_update_images: '/api/dashboard/update-images-post-type/',
    API_delete_image: '/api/dashboard/delete-image/',

    API_get_slider_items: '/api/dashboard/get-slider-items',
    API_create_item_slider: '/api/dashboard/create-item-slider',
    API_edit_item_slider: '/api/dashboard/edit-item-slider/',
    API_update_item_slider: '/api/dashboard/update-item-slider/',
    API_delete_item_slider: '/api/dashboard/delete-item-slider/',

    API_delete_order: '/api/dashboard/delete-order/',
    API_delete_mail: '/api/dashboard/delete-mail/',
    API_get_order: '/api/dashboard/get-order/',
    API_update_order: '/api/dashboard/update-order/',
    API_get_orders_activities: '/api/dashboard/get-orders-activities',
    API_get_orders_tours: '/api/dashboard/get-orders-tours',
    API_get_orders_city_breaks: '/api/dashboard/get-orders-city-breaks',
    API_get_orders_events: '/api/dashboard/get-orders-events',
    API_get_emails_contact: '/api/dashboard/get-messages-contact',
    API_get_mail: '/api/dashboard/get-mail/',
    API_update_mail: 'api/dashboard/update-mail/',

    API_get_orders_packages: '/api/dashboard/get-orders-packages',
    API_get_orders_packages_single: '/api/dashboard/get-orders-packages/',

    API_get_orders_tailor_made: '/api/dashboard/tailor-made',
    API_get_tailor_made: '/api/dashboard/tailor-made/',
    API_update_tailor_made: '/api/dashboard/update-tailor-made/',
    API_delete_tailor_made: '/api/dashboard/tailor-made/delete/',

    API_get_reviews: '/api/dashboard/get-reviews',
    API_search_review: '/api/dashboard/search-review',
    API_add_review: '/api/dashboard/add-review',
    API_create_review: '/api/dashboard/create-review',
    API_edit_review: '/api/dashboard/edit-review/',
    API_update_review: '/api/dashboard/update-review/',
    API_delete_review: '/api/dashboard/delete-review/',
    API_delete_review_image: '/api/dashboard/delete-review-image/',
    API_update_review_images: '/api/dashboard/update-review-images/',

    // Users
    API_get_users: '/api/dashboard/get-users',
    API_search_user: '/api/dashboard/search-user',
    API_create_user: '/api/dashboard/create-user',
    API_edit_user: '/api/dashboard/edit-user/',
    API_update_user: '/api/dashboard/update-user/',
    API_delete_user: '/api/dashboard/delete-user/',

    // FAQs
    API_get_faqs: '/api/dashboard/get-faqs',
    API_search_faq: '/api/dashboard/search-faq',
    API_create_faq: '/api/dashboard/create-faq',
    API_edit_faq: '/api/dashboard/edit-faq/',
    API_update_faq: '/api/dashboard/update-faq/',
    API_delete_faq: '/api/dashboard/delete-faq/',
    API_bulk_delete_faqs: '/api/dashboard/delete-faqs-bulk',

    // Package management API routes
    API_get_packages: '/api/dashboard/get-packages',
    API_get_all_packages: '/api/dashboard/get-all-packages',
    API_create_package: '/api/dashboard/create-package',
    API_edit_package: '/api/dashboard/edit-package/',
    API_update_package: '/api/dashboard/update-package/',
    API_delete_package: '/api/dashboard/delete-package/',
    API_get_package: '/api/get-package/',

    // Users
    API_get_users: '/api/dashboard/get-users',
    API_search_user: '/api/dashboard/search-user',
    API_create_user: '/api/dashboard/create-user',
    API_edit_user: '/api/dashboard/edit-user/',
    API_update_user: '/api/dashboard/update-user/',
    API_delete_user: '/api/dashboard/delete-user/',

    // FAQs
    API_get_faqs: '/api/dashboard/get-faqs',
    API_search_faq: '/api/dashboard/search-faq',
    API_create_faq: '/api/dashboard/create-faq',
    API_edit_faq: '/api/dashboard/edit-faq/',
    API_update_faq: '/api/dashboard/update-faq/',
    API_delete_faq: '/api/dashboard/delete-faq/',
    API_bulk_delete_faqs: '/api/dashboard/delete-faqs-bulk',

    // Legacy package API routes
    API_add_package: '/api/dashboard/add-package',
    API_update_package: '/api/dashboard/update-package/',
    API_delete_package: '/api/dashboard/delete-package/',
    API_get_package: '/api/dashboard/packages/',

    // New package management API routes
    API_get_packages: '/api/dashboard/get-packages',
    API_get_all_packages: '/api/dashboard/get-all-packages',
    API_add_new_package: '/api/dashboard/add-package',
    API_create_package: '/api/dashboard/create-package',
    API_edit_package: '/api/dashboard/edit-package/',
    API_update_new_package: '/api/dashboard/update-package/',
    API_delete_new_package: '/api/dashboard/delete-package/',
    API_bulk_delete_packages: '/api/dashboard/delete-packages-bulk',
    API_duplicate_package: '/api/dashboard/duplicate-package/',
    API_duplicate_event: '/api/dashboard/duplicate-event/',
    API_duplicate_tour: '/api/dashboard/duplicate-tour/',
    API_duplicate_luxury_travel: '/api/dashboard/duplicate-luxury-travel/',
    API_duplicate_travel_guide: '/api/dashboard/duplicate-travel-guide/',
    API_duplicate_travel_guide_category: '/api/dashboard/duplicate-travel-guide-category/',
    API_duplicate_article: '/api/dashboard/duplicate-article/',
    API_duplicate_blog_category: '/api/dashboard/duplicate-blog-category/',
    API_duplicate_tag: '/api/dashboard/duplicate-tag/',
    API_duplicate_category: '/api/dashboard/duplicate-category/',
    API_package_tags: '/api/dashboard/package-tags',
    API_package_guides: '/api/dashboard/package-guides',
    // Guides management API routes
    API_get_guides: '/api/dashboard/get-guides',
    API_create_guide: '/api/dashboard/create-guide',
    API_edit_guide: '/api/dashboard/edit-guide/',
    API_update_guide: '/api/dashboard/update-guide/',
    API_delete_guide: '/api/dashboard/delete-guide/',
    API_get_all_tours: '/api/dashboard/get-all-tours',
    API_get_all_excursions: '/api/dashboard/get-all-excursions',
    API_get_all_destinations: '/api/dashboard/get-all-destinations',

    API_add_package_images: '/api/dashboard/packages/',
    API_add_images: '/api/dashboard/packages/',
    API_delete_image_package: '/api/dashboard/images/',
    API_update_image_package: '/api/dashboard/images/',
    API_update_image_order: '/api/dashboard/packages/',
    API_add_card: '/api/dashboard/add-card',
    API_create_card: '/api/dashboard/create-card',
    API_edit_card: '/api/dashboard/edit-card/',
    API_update_card: '/api/dashboard/update-card/',
    API_delete_card: '/api/dashboard/delete-card/',
    API_duplicate_card: '/api/dashboard/duplicate-card/',

    // Settings
    API_get_settings: '/api/dashboard/settings',
    API_update_settings: '/api/dashboard/settings',
    API_get_settings_pages: '/api/dashboard/settings?key=pages',
    API_update_settings_pages: '/api/dashboard/settings?key=pages',

    // Public settings (front)
    API_get_public_settings: '/api/settings',

    /* ===================== Routes front office ========================== */
    API_get_data_home: '/api/get-data-home',
    API_links_navbar: '/api/links-navbar',
    API_links_footer: '/api/links-footer',
    API_newslatter: '/api/subscribe',

    API_get_tours_page: '/api/get-tours-page',
    API_get_tour: '/api/get-tour/',
    API_get_tour_categories_front: '/api/get-tour-categories-front',
    API_get_tours_by_category: '/api/get-tours-by-category/',
    API_get_activity: '/api/get-activity/',
    API_submit_review: '/api/add-review/',
    API_submit_customer_review: '/api/add-customer-review',
    API_submit_order: '/api/submit-order',
    API_submit_quote_request: '/api/submit-quote-request',

    API_get_city_break: '/api/get-city-break/',

    API_get_destinations_page: '/api/get-destinations-page',
    API_get_destination: '/api/get-destination/',
    API_get_destination_categories_front: '/api/get-destination-categories-front',
    API_get_destinations_by_category: '/api/get-destinations-by-category/',

    API_get_packages_page: '/api/get-packages-page',
    API_get_faqs_public: '/api/get-faqs/',
    API_get_faqs_index: '/api/get-faqs-index',
    API_get_faqs_by_travel_guide: '/api/get-faqs-by-travel-guide/',
    API_get_faqs_by_travel_guide_category: '/api/get-faqs-by-travel-guide-category/',
    API_get_faqs_by_item: '/api/get-faqs-by-item/',
    API_get_package: '/api/get-package/',
    API_get_package_categories_front: '/api/get-package-categories-front',
    API_get_packages_by_category: '/api/get-packages-by-category/',
    API_get_packages_tag: '/api/get-package-tag/',
    API_get_packages_from: '/api/get-package-from',
    API_get_packages_duration: '/api/get-package-duration',
    API_get_extras_by_ids: '/api/get-extras-by-ids',

    API_get_types_front: '/api/get-types-front',
    API_get_type: '/api/get-type/',
    API_get_activities_type: '/api/get-activities-type/',

    API_get_tours_type: '/api/get-tours-type/',
    API_get_tours_types: '/api/get-tours-types',

    API_get_activities_types: '/api/get-activities-types',
    API_get_activities_front: '/api/get-activities-front',

    API_get_tours_front: '/api/get-tours-front',

    API_get_city_breaks_front: '/api/get-city-breaks-front',

    API_contact_us: '/api/contact-us',
    API_map_location:
        'https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d3395.3065681352773!2d-8.0480812!3d31.6801861!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzHCsDQwJzQ3LjEiTiA4wrAwMic1MC4wIlc!5e0!3m2!1sen!2sma!4v1718065978687!5m2!1sen!2sma',
    API_video_src: 'https://player.vimeo.com/video/962416477?h=ff09b41be3',

    API_get_articles_front: '/api/get-articles-blog',
    API_get_categories_front: '/api/get-categories-front',
    API_get_category_front: '/api/get-category-front/',
    API_get_tags_front: '/api/get-tags-front',
    API_get_tag_front: '/api/get-tag-front/',
    API_get_article_front: '/api/get-article-front/',

    // Travel guides (front)
    API_get_travel_guides_front: '/api/get-travel-guides-front',
    API_get_travel_guide_front: '/api/get-travel-guide/',
    API_get_travel_guides_by_category_front: '/api/get-travel-guides-by-category/',
    API_get_travel_guide_categories_front: '/api/get-travel-guide-categories-front',
    API_get_travel_guides: '/api/get-travel-guides/',
    API_get_travel_guides_by_item: '/api/get-travel-guides-by-item/',

    API_search_general: '/api/get-search-general',

    API_get_events_front: '/api/get-events-front',
    API_get_single_event: '/api/get-event/',
    API_get_events_type: '/api/get-events-type/',
    API_get_event_categories_front: '/api/get-event-categories-front',
    API_get_events_by_category: '/api/get-events-by-category/',

    API_get_luxury_travels_front: '/api/get-luxury-travels-front',
    API_get_single_luxury_travel: '/api/get-luxury-travel/',
    API_get_luxury_travel_categories_front: '/api/get-luxury-travel-categories-front',
    API_get_luxury_travels_by_category: '/api/get-luxury-travels-by-category/',

    API_create_estimate: '/api/create-estimate',
    API_get_all_reviews: '/api/get-all-reviews',
    API_get_testimonials: '/api/get-testimonials-reviews',

    API_get_page: '/api/get-page/',

    API_get_visited_tours: '/api/get-visited-tours',
    API_get_visited_activities: '/api/get-visited-activities',
    API_get_visited_city_breaks: '/api/get-visited-city-breaks',
};
